import React from "react";
import {
    Box,
    Typography,
    Grid,
    Container,
    useTheme,
} from "@mui/material";
import Footer from "./Footer";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

const ContactUs = () => {
    const theme = useTheme();

    return (
        <Box>
            <Box
                sx={{
                    pt: { xs: 10, md: 12 },
                    pb: { xs: 6, md: 8 },
                    // background: `radial-gradient(
                    //     circle at top,
                    //     ${theme.palette.secondary.main} 0%,
                    //     #ffffff 65%
                    // )`,
                }}
            >
                <Container maxWidth="md">
                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "28px", md: "40px" },
                            fontWeight: 600,
                            textAlign: "center",
                            lineHeight: 1.1,
                            mb: 3,
                            color: theme.palette.text.primary,
                            animation: "fadeUp 0.9s ease-out both",
                            position: "relative",
                            display: "inline-block",
                            width: "100%",
                        }}
                    >
                        Get in{" "}
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 900,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                position: "relative",
                                display: "inline-block",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: "-4px",
                                    left: 0,
                                    width: "100%",
                                    height: "2px",
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                }
                            }}
                        >
                            touch
                        </Box>{" "}
                        with us
                    </Typography>

                    <Typography
                        variant="body1"

                        sx={{
                            textAlign: "center",
                            fontSize: { xs: "12px", sm: "14px", md: "16px" },
                            color: "#555",
                            maxWidth: 640,
                            mx: "auto",
                        }}
                    >
                        We’re here to help you. Whether you have questions, need
                        support, or want to collaborate — just reach out. Our
                        team is ready to assist you on your financial journey.
                    </Typography>
                </Container>
            </Box>

            <Box
                sx={{
                    // mt: 6,
                    pb: { xs: 2, md: 6 },
                    px: { xs: 2, md: 8 },
                    maxWidth: "1200px",
                    mx: "auto",
                    // background: "red"

                }}
            >
                <Grid container spacing={6} alignItems="center">
                    {/* MAP */}
                    <Grid item xs={12} md={6}>
                        <Box
                            component="img"
                            src="https://img.freepik.com/premium-vector/india-dotted-map-modern-halftone-style_141130-19154.jpg"
                            alt="India Map"
                            sx={{
                                width: "100%",
                                maxHeight: 480,
                                objectFit: "contain",
                                filter: "grayscale(25%)",
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                p: { xs: 4, md: 5 },
                                borderRadius: "24px",
                                background: `linear-gradient(
                                    180deg,
                                    #ffffff,
                                    ${theme.palette.secondary.main}
                                )`,
                                boxShadow: "0 30px 60px rgba(0,0,0,0.12)",
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                                transition: "all 0.4s ease",
                                "&:hover": {
                                    transform: "translateY(-8px)",
                                    boxShadow: "0 40px 80px rgba(0,0,0,0.18)",
                                },
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: "18px",
                                    color: theme.palette.primary.main,
                                }}
                            >
                                Contact Details
                            </Typography>

                            <Box sx={{ display: "flex", gap: 2 }}>
                                <LocationOnOutlinedIcon
                                    sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: 28,
                                    }}
                                />
                                <Typography variant="body1" sx={{ fontSize: "16px", color: "#333" }}>
                                    Plot No C-9, Asha Officers Colony
                                    <br />
                                    RK Puram, Secunderabad, Hyderabad
                                </Typography>
                            </Box>

                            <Box sx={{ display: "flex", gap: 2 }}>
                                <CallOutlinedIcon
                                    sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: 26,
                                    }}
                                />
                                <Typography variant="body1" sx={{ fontSize: "16px", color: "#333" }}>
                                    +91 95950 27710
                                </Typography>
                            </Box>

                            <Box sx={{ display: "flex", gap: 2 }}>
                                <EmailOutlinedIcon
                                    sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: 26,
                                    }}
                                />
                                <Typography variant="body1" sx={{ fontSize: "16px", color: "#333" }}>
                                    <a
                                        href="mailto:support@arthgyan.com"
                                        style={{
                                            color: "#333",
                                            textDecoration: "none",
                                        }}
                                    >
                                        support@arthgyan.com
                                    </a>
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Footer />
        </Box>
    );
};

export default ContactUs;
